import React, { Dispatch, FC, SetStateAction } from 'react';
import { t } from '../../../../utils/helpers';
import { AdditionalType, Tourney } from '../../model/interfaces';
import { Tournaments } from '../../../../pages/tournamentsPage/tournamentsPage';
import { PendingTournamentsItem } from './pendingTournamentsItem/pendingTournamentsItem';

type PropsType = {
  tournaments: Tournaments | null;
  setComponent: Dispatch<SetStateAction<AdditionalType | undefined>>;
  activeItem: string;
  setActiveItem: Dispatch<SetStateAction<string>>;
};

export const PendingTournaments: FC<PropsType> = ({
  tournaments,
  setComponent,
  activeItem,
  setActiveItem,
}: PropsType) => {

  function handlerShowAdditional(key: string, data: AdditionalType) {
    setActiveItem(key);
    setComponent(data);
  }

  function renderPendingList(tournaments: Tourney[]) {
    return tournaments.map((item, index) => {
      return (
        <PendingTournamentsItem
          item={item}
          handlerShowAdditional={handlerShowAdditional}
          activeItem={activeItem}
          key={item.TourneyID}
          index={index}
        />
      );
    });
  }

  const pendingListJSX = tournaments?.pending?.length && renderPendingList(tournaments.pending);

  return (
    <>
      <div className="tournaments__item-header pending__header">
        <div className="pending__header-title">{t('pending')}</div>
        <div className="pending__header-rules">{`${t('tournament')} / ${t(
          'rules'
        )}`}</div>
        <div className="pending__header-director">{t('director')}</div>
        <div className="pending__header-entry">{t('entry_fee')}</div>
        <div className="pending__header-time-start">{t('starts_in')}</div>
      </div>
      <div className="tournaments__item-content">{pendingListJSX}</div>
    </>
  );
};
